import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I_checkbox, I_inputs } from './../../../interfaces/pages/abm/abm-domain.interface';
import { ModalSize } from '@signal/component-library/efx-modal';

@Component({
    selector: 'app-modal-lateral',
    templateUrl: './modal-lateral.component.html',
    styleUrls: ['./modal-lateral.component.scss'],
    standalone: false
})
export class ModalLateralComponent {
  @Input() showModal: boolean = false;
  @Input() tituloModal: string = '';
  @Input() camposModal: { inputs: I_inputs[], checkboxs: I_checkbox[] };

  @Output() onBtnCancelar: EventEmitter<any> = new EventEmitter();
  @Output() onBtnGuardar: EventEmitter<any> = new EventEmitter();
  modalSize = ModalSize;
  constructor() { }

  showInputDependCheckbox({ depends }: I_inputs): boolean {
    if (depends) {
      const find = this.camposModal.checkboxs.find(checkbox => checkbox.nameService === depends)?.value;
      return find;
    }

    return true;
  }

  getReturnEditData(): { nameService: string, value: any }[] {
    const formatData: { nameService: string, value: any }[] = [];

    // Process inputs
    this.camposModal.inputs.forEach(input => {
      formatData.push({
        nameService: input.nameService,
        value: input.value
      });
    });

    // Process checkboxes
    this.camposModal.checkboxs.forEach(checkbox => {
      formatData.push({
        nameService: checkbox.nameService,
        value: checkbox.value
      });
    });

    return formatData;
  }

  didCancelModal(){
    this.onBtnCancelar.emit();
  }
}
